import React from 'react';
import Cookies from 'js-cookie';
import Button from '../../../shared/components/ui/Button';
import { TaskStatus } from './taskWorkflow';
import { actsAsOwner } from './ownership';

export function pendingOwnerTransfer(task) {
  return (task?.ownerTransfers || []).find((row) => row.status === 'Pending');
}

// The owner, or the company's builder acting as owner, may hand the task on.
// A transfer takes effect at once and supersedes a request still pending.
export function canRequestOwnerTransfer(task) {
  const closed =
    task?.status === TaskStatus.COMPLETED ||
    task?.status === TaskStatus.CANCELLED;
  return actsAsOwner(task) && !closed;
}

const OwnerTransferBanner = ({
  task,
  onTransfer,
  onCancel,
  onAccept,
  onDecline,
  busy
}) => {
  const userId = String(Cookies.get('userId') || '');
  const pending = pendingOwnerTransfer(task);
  const isOwner = actsAsOwner(task);
  const isTarget = pending && String(pending.to_user_id) === userId;
  const closed =
    task?.status === TaskStatus.COMPLETED ||
    task?.status === TaskStatus.CANCELLED;

  if (!isOwner && !isTarget) return null;
  if (closed && !pending) return null;
  if (isOwner && !pending && !onTransfer) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
      {pending && isTarget ? (
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-amber-900">
            {pending.fromUser?.name || 'The current owner'} asked you to take ownership of this task.
          </p>
          <div className="flex gap-2">
            <Button
              type="button"
              onClick={onDecline}
              disabled={busy}
              className="bg-white text-gray-800 px-4 py-2 rounded border hover:bg-gray-50"
            >
              Decline
            </Button>
            <Button
              type="button"
              onClick={onAccept}
              disabled={busy}
              className="bg-[#346C75] text-white px-4 py-2 rounded hover:bg-[#2a565e]"
            >
              Accept
            </Button>
          </div>
        </div>
      ) : isOwner && pending ? (
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-amber-900">
            Transfer pending for {pending.toUser?.name || 'another user'}. Owner is unchanged until they accept.
          </p>
          <Button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="bg-white text-gray-800 px-4 py-2 rounded border hover:bg-gray-50"
          >
            Cancel transfer
          </Button>
        </div>
      ) : isOwner && onTransfer && !closed ? (
        <div className="flex justify-end">
          <Button
            type="button"
            onClick={onTransfer}
            className="bg-[#346C75] text-white px-4 py-2 rounded hover:bg-[#2a565e]"
          >
            Transfer owner
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default OwnerTransferBanner;
